var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.commentData
    ? _c(
        "pui-comment",
        {
          attrs: {
            "author-username": _vm.modifiedBy,
            "creation-date": _vm.commentData.createdAt,
            "edit-date": _vm.commentData.modifiedAt,
            comment: _vm.commentData.text,
          },
        },
        [
          _vm.commentData.taggedUser.length > 0
            ? _c("template", { slot: "additional-content" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "completeness-check-modal-comment__tagged-users",
                  },
                  [_vm._v(" " + _vm._s(_vm.taggedUsers) + " ")]
                ),
              ])
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }